package com.ives.modules.ecg;

import com.ives.utils.Remoting.ECGLine;
import com.er453r.hxcompo.Component;

class ECGLineView extends Component{
	private var ecgLine:ECGLine;

	public function new(ecgLine:ECGLine){
		this.ecgLine = ecgLine;

		label.innerHTML = ecgLine.name;
	}

	public function update(ratio:Float = 0){
		path.style.transform = 'translate(-${100 * ratio}%, 0)';
	}

	public function init(ratio:Float = 0){
		var ecgWidth:Float = container.clientWidth;
		var ecgHeight:Float = container.clientHeight;

		var pathString:String = '';

		var scale:Float = 1.0 / (ecgLine.max - ecgLine.min);

		for(n in 0...ecgLine.values.length){
			var width:Float = ecgWidth/2 + n;
			var height:Float = ecgHeight * (1 - ((ecgLine.values[n] - ecgLine.min) * scale));

			if(n == 0)
				pathString += 'M ${width} ${height}';
			else
				pathString += ' L ${width} ${height}';
		}

		path.setAttribute("d", pathString);

		update(ratio);

		fineGrid.style.backgroundSize = '50px 50px';
		fineGrid.style.backgroundImage = 'linear-gradient(to right, #ffa6ad 1px, transparent 1px), linear-gradient(to bottom, #ffa6ad 1px, transparent 1px)';

		container.style.backgroundSize = '10px 10px';
		container.style.backgroundImage = 'linear-gradient(to right, #ffd7de 1px, transparent 1px), linear-gradient(to bottom, #ffd7de 1px, transparent 1px)';
	}
}
